module.exports = __webpack_public_path__ + "fonts/manrope-light.031e2fb8.woff2";